import type { HTMLAttributes } from 'react'
import { Toaster } from 'react-hot-toast'
import GlobalStyles from './GlobalStyles'
import PostFormModal from './Post/PostFormModal'
import RepostFormModal from './Post/RepostForm/RepostFormModal'
import ServiceWorkerManager from './ServiceWorkerManager'
import WhatsNewModal from './WhatsNewModal'
import WhatsNewTip from './WhatsNewTip'
import YellowMemberRightsModal from './YellowMemberRightsModal'

export interface GlobalComponentsProps extends HTMLAttributes<HTMLDivElement> {}

export default function GlobalComponents({ ...props }: GlobalComponentsProps) {
	return (
		<>
			<WhatsNewTip />
			<YellowMemberRightsModal />
			<PostFormModal />
			<RepostFormModal />
			<Toaster />
			<WhatsNewModal />
			<ServiceWorkerManager />
			<GlobalStyles />
		</>
	)
}
